import { useQuery } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export interface ContactDetail {
  id: number;
  contact_id: number;
  type: string; // 'email' or 'phone'
  value: string;
  label?: string;
  is_primary: boolean;
  created_at: string;
}

export interface ContactAssociation {
  id: number;
  contact_id: number;
  location_id?: number;
  building_id?: number;
  unit_id?: number;
  community_id?: number;
  created_at: string;
  location?: {
    id: number;
    name: string;
  };
  building?: {
    id: number;
    name: string;
  };
  unit?: {
    id: number;
    name: string;
  };
  community?: {
    id: number;
    name: string;
  };
}

export interface Contact {
  id: number;
  name: string;
  user_id?: string;
  role: string;
  metadata?: Record<string, unknown>;
  created_at: string;
  details: ContactDetail[];
  associations: ContactAssociation[];
}

export type ApiResponse_GetAll_CommunityContact = Contact[];

export type ApiRequest_GetAll_CommunityContact = {
  community_id: number;
};

const ENDPOINT = 'contacts/community';
const METHOD = 'GET';

export const QUERY_KEY = (communityId?: number) => ['contacts', 'community', communityId];

export const useGetCommunityContacts = (communityId: number, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    queryKey: QUERY_KEY(communityId),
    queryFn: async (): Promise<ApiResponse_GetAll_CommunityContact> =>
      handleApiCall<ApiResponse_GetAll_CommunityContact, ApiRequest_GetAll_CommunityContact>(
        session,
        METHOD,
        ENDPOINT,
        {
          community_id: communityId,
        }
      ),
    enabled: enabled && !!communityId && !!session,
  });
};